import { useMemo } from 'react'
import { transformReceipt } from 'util/transform'
import { supportedStepType } from '../utils/stepHelpers'

export const useBreakData = (rawBrk, isEmbed) =>
  useMemo(() => {
    const brk = { ...rawBrk }

    brk.steps = (rawBrk.steps || [])
      .filter(step => supportedStepType(step.type))
      .map((step, i) => ({ ...step, position: i + 1 }))

    if (isEmbed) brk.platform = 'EMBED'
    else brk.shareUrl = ''

    brk.permalink = brk.permaLink

    if (!brk.navigationType) {
      brk.navigationType = brk.hasLeftNav ? 'LEFT' : 'NONE'
    }

    brk.steps = brk.steps.map(step =>
      step.type === 'RECEIPT_VERIFICATION' ? transformReceipt(brk, step) : step,
    )

    return brk
  }, [rawBrk, isEmbed])
